import { useEffect, useReducer } from "react";

const initialInputState = {
  value: "",
  dialCode: "",
  rawPhone: "",
  isTouched: false,
};
const inputStateReducer = (state, action) => {
  if (action.type === "INPUT") {
    return { value: action.value, isTouched: state.isTouched };
  }
  if (action.type === "PHONE") {
    return {
      value: action.value,
      dialCode: action?.data?.dialCode || "",
      rawPhone:
        action?.data &&
        action.value.slice(action.data.dialCode.length + 1, 13).trim(),
      isTouched: state.isTouched,
    };
  }
  if (action.type === "BLUR") {
    return {
      value: state.value,
      dialCode: state.dialCode,
      rawPhone: state.rawPhone,
      isTouched: true,
    };
  }
  if (action.type === "RESET") {
    return { value: "", dialCode: "", rawPhone: "", isTouched: false };
  }
  return initialInputState;
};

export default function useInput(
  validateValue,
  defaultValue = { type: "", value: "" }
) {
  const [inputState, dispatch] = useReducer(
    inputStateReducer,
    initialInputState
  );

  useEffect(() => {
    if (defaultValue?.type == "text") {
      dispatch({ type: "INPUT", value: defaultValue.value });
    }
    if (defaultValue?.type == "number") {
      dispatch({
        type: "PHONE",
        value: defaultValue.value,
        data: null,
      });
    }
  }, [defaultValue.value]);

  const valueIsValid = validateValue(inputState.value);
  const hasError = !valueIsValid && inputState.isTouched;

  const phoneValueIsValid = validateValue(inputState.value);
  const phoneHasError = !phoneValueIsValid && inputState.isTouched;

  const valueChangeHandler = (e, value) => {
    console.log("hello1234", e.target.type);

    dispatch({
      type: "INPUT",
      value:
        e.target.type == "text"
          ? e?.target?.value.substring(0, 40)
          : e?.target?.value || value,
    });
  };

  const reactPhoneChangeHandler = (value, data, e, formattedValue) => {
    dispatch({
      type: "PHONE",
      value: e?.target?.defaultValue || value,
      data: data,
    });
  };

  const inputBlurHandler = () => {
    dispatch({ type: "BLUR" });
  };

  const reset = () => {
    dispatch({ type: "RESET" });
  };

  return {
    value: inputState.value,
    dialCode: inputState?.dialCode ? "+" + inputState.dialCode : "",
    rawPhone: inputState.rawPhone,
    isTouched: inputState.isTouched,
    isValid: valueIsValid,
    hasError,
    phoneIsValid: phoneValueIsValid,
    phoneHasError,
    valueChangeHandler,
    reactPhoneChangeHandler,
    inputBlurHandler,
    reset,
  };
}
